import React from 'react';

export default function Test2() {
  return <div>Test2</div>;
}
